<template>
  <div>
    <div>农机服务商名称：{{ info.busName }}</div>
    <div>联系方式：{{ info.phone }}</div>
    <div>地址：{{ info.busAddress }}</div>
    <div class="score-container">
      综合评分：
      <div v-if="info.average" class="star-rating">
        <span
          v-for="index in 5"
          :key="index"
          :class="['star', { 'active': index <= starCount }]"
        >★</span>
      </div>
      <div v-else>暂无评分</div>
      <!-- {{ info.average ? `(${info.average})` : "(暂无评分)" }} -->
    </div>
    <!-- <div>经营范围：{{ info.busRange }}</div> -->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: ['info'],
  computed: {
    starCount() {
      return Math.round(this.info.average) || 0;
    }
  },
  methods: {

  }
};
</script>
<style lang="less" scoped>
.score-container {
  display: flex;
  align-items: center;
  margin: 8px 0;

  .star-rating {
    margin-left: 8px;
    .star {
      color: #cccccc;
      font-size: 16px;
      margin-right: 2px;
      &.active {
        color: #ffa500;
      }
    }
  }
}
</style>
